/**
 * Maps API error codes (docs/api.md) and identity-provider errors to i18n
 * keys, so every sign-in problem shows a translated, actionable message.
 */
import { ApiError } from '../api/client';
import { AuthFlowError } from './types';

const API_CODES: Record<string, string> = {
  NOT_PROVISIONED: 'auth.notProvisioned',
  DISABLED: 'auth.disabled',
  DOMAIN_NOT_ALLOWED: 'auth.domainNotAllowed',
  WRONG_METHOD: 'auth.wrongMethod',
  MFA_REQUIRED: 'auth.mfaRequired',
  EMAIL_NOT_VERIFIED: 'ui.auth.emailNotVerified',
  UNAUTHENTICATED: 'ui.auth.sessionExpired',
  NETWORK: 'ui.auth.offline',
  UPGRADE_REQUIRED: 'ui.version.required',
};

const FLOW_CODES: Record<string, string> = {
  INVALID_CREDENTIALS: 'ui.auth.invalidCredentials',
  TOO_MANY_ATTEMPTS: 'ui.auth.tooManyAttempts',
  INVALID_CODE: 'ui.auth.invalidCode',
  USER_DISABLED: 'auth.disabled',
  NETWORK: 'ui.auth.offline',
  NOT_CONFIGURED: 'ui.auth.notConfigured',
  BLOCKED: 'auth.domainNotAllowed',
  REAUTH_REQUIRED: 'ui.mfa.signInAgain',
  UNSUPPORTED: 'ui.auth.googleNativeUnsupported',
};

export function authErrorKey(err: unknown): string {
  if (err instanceof AuthFlowError) return FLOW_CODES[err.code] ?? 'ui.auth.unknown';
  if (err instanceof ApiError) return API_CODES[err.code] ?? 'ui.auth.unknown';
  if (typeof err === 'string') return API_CODES[err] ?? FLOW_CODES[err] ?? 'ui.auth.unknown';
  return 'ui.auth.unknown';
}

/** The API asks the device to wipe local data (account disabled, ADR-0021). */
export function isWipeRequest(err: unknown): boolean {
  return err instanceof ApiError && err.code === 'DISABLED' && !!(err.details as { wipe?: boolean } | undefined)?.wipe;
}
